// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'
import moment from 'moment'

import { SpanWithData, NavLink } from '../../'

export const MessageTableItem = ({ employerId, status, identityId, identityFullName, identityIdentityValue, content, createdAt, action, expandMessage, onClick }) => (
  <tr>
    <td>
      <NavLink to={`/employer/${employerId}/employees/${identityId}`}>
        {identityFullName}
      </NavLink>
    </td>
    <td>
      {identityIdentityValue}
    </td>
    <td>
      <SpanWithData forField="TelegramMessageStatus" searchKey={status} />
    </td>
    <td>
      {createdAt
        ? moment().isSame(moment(createdAt), 'day')
          ? moment(createdAt).format('hh:mm a')
          : moment(createdAt).format('lll')
        : '-'
      }
    </td>
    <td>
      {action}
    </td>
  </tr>
)



// WEBPACK FOOTER //
// ./src/components/messageplus/employer-bulk-message-telegram-messages/MessageTableItem.js